import _ from "lodash";
import axios from "axios";
import { sisi_api_url, sisikong_url } from "..";
import { source_entity } from "../../context";
import type { MarketType } from "../../definitions";

export async function fetchAirportAutocomplete({ name }: { name: string }) {
	try {
		const response = await axios.get(
			`${sisi_api_url}/flightengine/airport_autocomplete/`,
			{ params: { name } },
		);
		return response.data;
	} catch {
		return null;
	}
}

export async function updateAirportScore({ iata }: { iata: string }) {
	try {
		const response = await axios.get(
			`${sisi_api_url}/flightengine/airport_autocomplete/update_score`,
			{ params: { iata } },
		);
		return response.data;
	} catch {
		return null;
	}
}

export async function poiAutoComplete({ query }: { query: string }) {
	try {
		const response = await axios.get(
			`${sisikong_url}/veritascms/api/poi_autocomplete/`,
			{ params: { query } },
		);
		return response.data;
	} catch {
		return null;
	}
}

export async function poiGeodata({ uid }: { uid: string }) {
	try {
		const response = await axios.get(
			`${sisikong_url}/veritascms/api/poi_details/geodata_only/`,
			{ params: { uid } },
		);

		return response.data;
	} catch {
		return null;
	}
}

export async function getDestQuickInfo({
	destinations,
}: { destinations: string[] }) {
	try {
		const response = await axios.get(
			`${sisikong_url}/veritascms/api/destination-quick-info/`,
			{ params: { destinations } },
		);

		return response.data;
	} catch {
		return null;
	}
}

export async function updateHotelScore({ uid }: { uid: string }) {
	try {
		const response = await axios.post(
			`${sisi_api_url}/accommodator/autocomplete/update_score/`,
			{
				supplier: "hotelston", // TODO: this should be dynamically selected.
				uid,
			},
		);
		return response.data;
	} catch {
		return null;
	}
}

export async function openTableAutocomplete({ name }: { name: string }) {
	const params = { name };
	try {
		const result = await axios.get(
			`${sisi_api_url}/restaurants/opentable/autocomplete`,
			{ params },
		);
		return _.get(result, "data");
	} catch {
		return null;
	}
}

export async function fetchPortAutocomplete({ name }: { name: string }) {
	try {
		const response = await axios.get(
			`${sisi_api_url}/vesselengine/ports/autocomplete/`,
			{ params: { name } },
		);
		return response.data;
	} catch {
		return null;
	}
}

export async function fetchTrainStationsAutocomplete({
	search_query,
	market_type,
}: {
	search_query: string;
	market_type: MarketType;
}) {
	try {
		const response = await axios.get(
			`${sisi_api_url}/railengine/get_destination/`,
			{ params: { search_query, source_entity, market_type } },
		);
		return response.data;
	} catch {
		return null;
	}
}
